// src/components/Sidebar/Sidebar.js
import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Sidebar.css"; // Make sure your CSS file defines the classes below
import AuthContext from "../../contexts/AuthProvider";
import { useContext } from "react";
import { API_URL } from "../../utils/config";
import { getUserRole, USER_ROLES } from "../../utils/UsersPermissions";
const baseUrl = API_URL;

const Sidebar = ({ menuToggle, setMenuToggle }) => {
  const { t, i18n } = useTranslation("dash");
  const navigate = useNavigate();
  const location = useLocation();
  const activeComponent = location.pathname;
  const { isAuthenticated } = useContext(AuthContext);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1280);
  const [bookingCount, setBookingCount] = useState("");
  const [messagesCount, setMessagesCount] = useState("");
  
  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

  const isRTL = i18n.language === "ar";

  // Handle responsive sidebar
  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 1280);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuStyle = {
    [isRTL ? "right" : "left"]: isTablet ? (menuToggle ? "0" : "-250px") : "0",

    direction: isRTL ? "rtl" : "ltr",
    borderRight: isRTL ? "none" : "1px solid #E5E7EB",
    borderLeft: isRTL ? "1px solid #E5E7EB" : "none",
  };

  const fetchBookingCount = async () => {
    try {
      if (!isAuthenticated) {
         
        return;
      }

      const response = await fetch(`${baseUrl}/api/v1/attnd-venue/newBookings`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          lang: getLangFromLocalStorage(),
        },
      });

      if (response.status === 401) {
        navigate("/login");
        throw new Error("Unauthorized access. Please log in again.");
      }
      if (!response.ok) {
        throw new Error("Failed to fetch catering");
      }

      const invitation = await response.json();
      return invitation.count;
    } catch (error) {    // if (eventTypes){
    //   const raw = typeof eventTypes === "string"
    //     ? eventTypes.split(",").map((item) => item.trim()).filter(Boolean)
    //     : Array.isArray(eventTypes) ? eventTypes : [];
    //   const ids = raw.map((v) => (v === "" ? NaN : parseInt(v, 10))).filter((n) => !isNaN(n) && n > 0);
    //   if (ids.length > 0) {
    //     whereConditions.venue_type_id = { [Op.in]: ids };
    //   }
    // }
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
         
        navigate("/login");
      }
      return [];
    }
  };
  const fetchMessagesCount = async () => {
    try {
      if (!isAuthenticated) {
        navigate("/login");
        return;
      } 
      const response = await fetch(`${baseUrl}/api/v1/chat/newMessages/venue`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          lang: getLangFromLocalStorage(),
        },
      });
      if (response.status === 401) {
        navigate("/login");
        throw new Error("Unauthorized access. Please log in again.");
      }
      if (!response.ok) {
        throw new Error("Failed to fetch messages count");
      }
      const data = await response.json();
      return data.count;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
         
        navigate("/login");
      }
      return 0;
    }
  };
  // Fetch booking count every minute
  useEffect(() => {
    const interval = setInterval(() => {
      fetchBookingCount().then((count) => setBookingCount(count));
      fetchMessagesCount().then((count) => setMessagesCount(count));
    }, 60000);
    fetchBookingCount().then((count) => setBookingCount(count));
    fetchMessagesCount().then((count) => setMessagesCount(count));
    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="sidebar-sidebar" style={menuStyle}>
      <ul className="sidebar-content">
        <li>
          <NavLink
            onClick={() => setMenuToggle(false)}
            to="/dashboard"
            className={
              activeComponent === "/dashboard"
                ? "link-dashboard-active"
                : "link-dashboard"
            }
          >
            <img
              className="dashboard-icon"
              src="/activity.svg"
              alt={t("Sidebar.dashboardIconAlt")}
            />
            {t("Sidebar.dashboard")}
          </NavLink>
        </li>
        <li>
          <NavLink
            onClick={() => setMenuToggle(false)}
            to="/venues"
            className={
              activeComponent === "/venues"
                ? "link-dashboard-active"
                : "link-dashboard"
            }
          >
            <img
              className="dashboard-icon"
              src="/building.svg"
              alt={t("Sidebar.venuesIconAlt")}
            />
            {t("Sidebar.venues")}
          </NavLink>
        </li>
        <li>
          <NavLink
            onClick={() => setMenuToggle(false)}
            to="/addons"
            className={
              activeComponent === "/addons"
                ? "link-dashboard-active"
                : "link-dashboard"
            }
          >
            <img
              className="dashboard-icon"
              src="/truck.svg"
              alt={t("Sidebar.addonsIconAlt")}
            />
            {t("Sidebar.addons")}
          </NavLink>
        </li>
        <li>
          <NavLink
            onClick={() => {
              setMenuToggle(false);
              setBookingCount("");
            }}
            to="/bookings"
            className={`booking-link ${
              activeComponent === "/bookings"
                ? "link-dashboard-active"
                : "link-dashboard"
            }`}
          >
            <img
              className="dashboard-icon"
              src="/calendar.svg"
              alt={t("Sidebar.bookingsIconAlt")}
            />
            {t("Sidebar.bookings")}{" "}
            {(Array.isArray(bookingCount)
              ? bookingCount.length > 0
              : bookingCount > 0) && (
              <span className="unread-indicator-sidebar">{bookingCount}</span>
            )}
          </NavLink>
        </li>
                {/* organizer - Only show for venue owners */}
        {getUserRole() === USER_ROLES.OWNER && (
        <li>
          <NavLink
            onClick={() => setMenuToggle(false)}
            to="/organizers"
            className={
              activeComponent === "/organizers"
                ? "link-dashboard-active"
                : "link-dashboard"
            }
          >
            <img
              className="dashboard-icon"
              src="/user-octagon.svg"
              alt={t("Sidebar.organizersIconAlt")}
            />
            {t("Sidebar.organizers")}
          </NavLink>
        </li>
        )}
        {/* messages - Only show for venue owners */}
        {getUserRole() === USER_ROLES.OWNER && (
         <li>
          <NavLink
            onClick={() => setMenuToggle(false)}
            to="/messages"
            className={
              activeComponent === "/messages"
                ? "link-dashboard-active"
                : "link-dashboard"
            }
          >
            <img
              className="dashboard-icon"
              src="/activity.svg"
              alt={t("Sidebar.messagesIconAlt")}
            />
            {t("Sidebar.messages")}{" "}
            {(Array.isArray(messagesCount)
              ? messagesCount.length > 0
              : messagesCount > 0) && (
              <span className="unread-indicator-sidebar">{messagesCount}</span>
            )}
          </NavLink>
        </li> 
        )}
        <li>
          <NavLink
            onClick={() => setMenuToggle(false)}
            to="/reviews"
            className={
              activeComponent === "/reviews"
                ? "link-dashboard-active"
                : "link-dashboard"
            }
          >
            <img
              className="dashboard-icon"
              src="/heart.svg"
              alt={t("Sidebar.reviewsIconAlt")}
            />
            {t("Sidebar.reviews")}
          </NavLink>
        </li>
        <li>
          <NavLink
            onClick={() => setMenuToggle(false)}
            to="/settings"
            className={
              activeComponent === "/settings"
                ? "link-dashboard-active"
                : "link-dashboard"
            }
          >
            <img
              className="dashboard-icon"
              src="/setting-2.svg"
              alt={t("Sidebar.settingsIconAlt")}
            />
            {t("Sidebar.settings")}
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
